declare const $: any;
export class EcommBase {
    constructor() {
        (function () {
            "use strict";
            $(document).ready(function () {
                $(document).on("click", ".cManikProductAddToCart", function (e) {
                    e.preventDefault();
                    ManageCartItems($(this).attr("producthandle"), "A");
                });

                $(document).on("click", ".cRemoveCartItem", function (e) {
                    e.preventDefault();
                    ManageCartItems(e.target.getAttribute("productcode"), "R");
                });

                $(document).on("click", ".cIncItemQty", function (e) {
                    e.preventDefault();
                    ManageCartItems(e.target.getAttribute("productcode"), "A");
                });

                $(document).on("click", ".cDecItemQty", function (e) {
                    e.preventDefault();
                    ManageCartItems(e.target.getAttribute("productcode"), "D");
                });

                $(document).on("click", "#btnContinueShopping", function (e) {
                    e.preventDefault();
                    $(".shopping-cCartItem").show();
                    $("#dvCheckout").hide();
                });

                /* To Clear Filter And Populate All Products */

                $(document).on("click", ".cShoppingBarEfct-head", function (e) {
                    $(".cManikCategories").removeClass("cProductCats-item_active");
                    e.preventDefault();
                    window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.Local_EventOnFilterChange(null, null));
                });

                /* Ends Filetr All Products*/

                $(document).on("click", "#ManikCartIcon", function (e) {
                    e.preventDefault();
                    let targetControl = getOnDemandDivs().find(item => { return item.id == 'odECOMM-CART' }).targetcontrol;
                    if (targetControl === "manikPopup") {
                        $("#ONDEMANDPLUGINS").show();
                        $("#myModal .modal-header > h2").each(function () {
                            var text = $(this).text();
                            $(this).text(text.replace('#PAGEHEADER#', getOnDemandDivs().find(item => { return item.id == 'odECOMM-CART' }).pgheader));
                        });
                        $("#myModal").modal();
                    }

                    $(".container > h1").each(function () {
                        var text = $(this).text();
                        $(this).text(text.replace('#PAGEHEADER#', getOnDemandDivs().find(item => { return item.id == 'odECOMM-CART' }).pgheader));
                    });

                    switch (e.currentTarget.getAttribute('popupcontext')) {
                        case "CARTICON":
                            ManageCartItems(null, null);
                            break;
                    }
                });

                $('[data-dismiss="modal"]').click(function (e) {
                    $("#ONDEMANDPLUGINS").hide();
                });

                $(document).on("click", "#btnProceedToCheckout", function (e) {
                    e.preventDefault();
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.Checkout();
                    });
                });

                $(document).on({
                    click: function (e) {
                        e.preventDefault();
                        $(".cManikCategories").removeClass("cProductCats-item_active");
                        $(this).addClass("cProductCats-item_active");
                        Local_EventOnFilterChange($(".cManikCategories").attr("value"), "C");
                    },
                    change: function (e) {
                        e.preventDefault();
                        Local_EventOnFilterChange(e.target.value, "C");
                    }
                }, ".cManikCategories");

                $(document).on({
                    click: function (e) {
                        e.stopPropagation();
                        Local_EventOnFilterChange($(".cManikSubCategory").attr("value"), "SC");
                    }
                }, ".cManikSubCategory");

                $(document).on("click", ".cManikProductViewDetails", function (e) {
                    e.preventDefault();
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.PopulateProductDetails(e.target.getAttribute("producthandle"));
                    });
                });

                const debounce = (func, delay) => {
                    let debounceTimer;
                    return function () {
                        const context = this;
                        const args = arguments;
                        clearTimeout(debounceTimer);
                        debounceTimer = setTimeout(() => func.apply(context, args), delay);
                    }
                }

                $(document).on({
                    keyup: debounce(Local_EventOnFilterChange, 500),
                }, "#txtSearchProducts");

                /*Only POS Related Scripts Are Below */

                $(document).on({
                    click: OnCartItemChange,
                    change: OnCartItemChange
                }, ".cManikCartItems");

                $(document).on("click", ".cManikPOSNumValue", UpdateProductQuantity);

                $(document).on({
                    click: function () {
                        $(".cManikPOSCartItem").removeClass("cCartItem_active");
                        $(this).addClass("cCartItem_active");
                    }
                }, ".cManikPOSCartItem");

                $(document).on("click", ".cManikPOSAdd", OnQtyPlus);

                $(document).on("click", ".cManikPOSDlt", OnQtyMinus);

                $(document).on("click", '.cManikPOSQtybtn, .cManikPOSDiscbtn, .cManikPOSPricebtn', function () {
                    $("button").removeClass("cCalculatorBtn_active");
                    $(this).addClass("cCalculatorBtn_active");
                });

                $(document).on("click", ".cManikPOSCross", function (e) {
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.ClearCartProduct($(".cCartItem_active").attr("producthandle"), $(".cCalculatorBtn_active").attr("usedfor"));
                    });
                });

                /* Creating POS Dynamic Tabs */

                $(document).on("click", ".cManikPOSNewTab", function (e) {
                    e.preventDefault();
                    window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.CreateNewTabAndPopulate());
                });

                $(document).on("click", "#manikPOSTabsContainer li", function (e) {
                    e.preventDefault();
                    window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.BindCart());
                });

                /*End Creating Tabs*/

                /*POS Keyboard Enables Here*/
                $(document).on("keyup", function (e) {
                    switch (e.keyCode) {
                        case 8: //Backspace
                        case 38: // up arrow key
                        case 40: // down arrow key
                        case 48: //one 
                        case 49: //one 
                        case 49: //Two 
                        case 50: //Three 
                        case 51: //Four
                        case 52: //Five
                        case 53: //Six
                        case 54: //Seven
                        case 55: //Eight
                        case 56: //Nine
                            e.preventDefault();
                            UpdateProductQuantity(e);
                            break;
                        case 187: //Plus Key
                            e.preventDefault();
                            break;
                        case 189: // minus
                            e.preventDefault();
                            break;
                    }
                });
                /* Keyboard Events listening Ends Here */

                /* Start Products Attributes Change */
                $(document).on("change", ".cChooseProdSize", function (e) {
                    let SelectedOption = e.target.options[e.target.options.selectedIndex];
                    let mrp = SelectedOption.getAttribute("mrp");
                    let offerprice = SelectedOption.getAttribute("offerprice");
                    // let membersofferprice = SelectedOption.getAttribute("membersofferprice");
                    let ProductHandle = e.target.value.split('_')[1];
                    let StoreHandle = GetStoreHandle();
                    let currency = JSON.parse(localStorage.getItem(StoreHandle + "_ManikStoreMetaData"))[0].CurrencySymbol;
                    $(".PRICE_" + ProductHandle).html(mrp + " " + currency);
                    $(".cPRICE_" + ProductHandle).html(offerprice + " " + currency);
                });
                /* Ends Product Attributes Change */

                function OnCartItemChange(e) {
                    let x = e.target.getAttribute("productcode");
                    //alert(x);
                }

                function UpdateProductQuantity(e) {
                    let target = e.target.tagName.toUpperCase();
                    if (target !== "INPUT" && target !== "TEXTAREA") {
                        let InputValue;
                        if (e.type === "keyup") {
                            InputValue = (e.keyCode === 8) ? 0 : e.key;
                        } else {
                            InputValue = e.target.innerText === "X" ? 0 : e.target.innerText;
                        }
                        let ProductHandle = $(".cCartItem_active").attr("producthandle");
                        window['angularComponentRef'].zone.run(() => {
                            switch ($(".cCalculatorBtn_active").attr("usedfor")) {
                                case "Qty":
                                    if (e.key === "Backspace") {
                                        window['angularComponentRef'].component.ClearCartProduct($(".cCartItem_active").attr("producthandle"), $(".cCalculatorBtn_active").attr("usedfor"));
                                    }
                                    else {
                                        window['angularComponentRef'].component.ManageCart(ProductHandle, InputValue);
                                    }
                                    break;
                                case "disc":
                                    window['angularComponentRef'].component.AddProductDiscount(ProductHandle, InputValue);
                                    break;
                                case "price":
                                    window['angularComponentRef'].component.ModifyProductPrice(ProductHandle, InputValue);
                                    break;
                            }
                        });
                    }
                }

                function OnQtyPlus(e) {
                    let ProductHandle = $(".cCartItem_active").attr("producthandle");
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.ManageCart(ProductHandle, null, "A");
                    });
                }

                function OnQtyMinus(e) {
                    let ProductHandle = $(".cCartItem_active").attr("producthandle");
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.ManageCart(ProductHandle, null, "D");
                    });
                }

                function Local_EventOnFilterChange(catid, type) {
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.oProcessMicroSite.IsProcessing = true;
                        window['angularComponentRef'].component.oProcessMicroSite.ProcessingText = "Fetching Products...";
                        window['angularComponentRef'].component.Local_EventOnFilterChange(catid, type);
                    });
                }

                function ManageCartItems(product, action) {
                    window['angularComponentRef'].zone.run(() => {
                        window['angularComponentRef'].component.ManageCart(product, action);
                    });
                }

                function GetStoreHandle() {
                    return window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.StoreHandle);
                }

                function getOnDemandDivs() {
                    return window['angularComponentRef'].zone.run(() => window['angularComponentRef'].component.OnDemandDivArray);
                }
            });
        }());
    }
}
